// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__c24gg","header":"PatientQuestionnaire_header__nCT0V","info":"PatientQuestionnaire_info__260xL"};